<template>
  <div>
    <h1 class="title">Jokes</h1>
    <div v-for="post in posts" :key="post.id" class="column is-four-quarter">
      <div class="card post-preview" @click="openModal(post)">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <h2 class="title is-4">{{ post.title }}</h2>
              <p>😂</p>
              <p class="subtitle is-6">{{ post.excerpt }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Posts -->
    <div class="modal" v-if="isModalOpen" @click.self="closeModal">
      <div class="modal-content" ref="modalContent">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="currentPost">
          <h2>{{ currentPost.title }}</h2>
          <p>😂</p>
           <p>😂</p>
          <p>{{ currentPost.fullText }}</p>
        </div>
        <button @click="prevPost" class="nav-button prev">&lt;</button>
        <button @click="nextPost" class="nav-button next">&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs';

export default {
  name: 'JokesPage',
  data() {
    return {
      posts: [   { id: 1, title: 'The Kikuyu Charm', excerpt: 'A joke about Kikuyu girls and their love for Waru...', fullText: 'Why did the Kikuyu girl bring a bag of potatoes to the date? Because she wanted to have a "mash"ed time with you!' },
  { id: 2, title: 'Money Matters', excerpt: 'A playful joke about Kikuyu girls and money...', fullText: 'Why did the Kikuyu girl refuse to date a broke guy? Because she knows her heart needs "capital" investment!' },
  { id: 3, title: 'Fast and Furious', excerpt: 'A joke about Kalenjin girls and their speed...', fullText: 'Why did the Kalenjin girl win the marathon? Because even her love can’t catch up to her speed!' },
  { id: 4, title: 'The Luo Booty', excerpt: 'A light-hearted joke about Luo girls and their physical traits...', fullText: 'Why do Luo girls never get lost? Because they always have a “big” sense of direction!' },
  { id: 5, title: 'The Kisii Talker', excerpt: 'A joke about Kisii girls and their chatty nature...', fullText: 'Why did the Kisii girl bring a microphone to the party? Because she wanted everyone to hear her “loose” lips!' },
  { id: 6, title: 'The Kamba Witch', excerpt: 'A playful joke about Kamba girls and their cultural background...', fullText: 'Why did the Kamba girl bring a crystal ball to the date? To see if your future includes “magical” moments together!' },
  { id: 7, title: 'Waru Love', excerpt: 'A joke about Kikuyu girls and their love for potatoes...', fullText: 'Why did the Kikuyu girl take you to a potato farm? Because she wanted you to know her love is “down-to-earth”!' },
  { id: 8, title: 'Money Moves', excerpt: 'A joke about Kikuyu girls and financial matters...', fullText: 'Why did the Kikuyu girl carry a calculator on your date? To make sure her love interest adds up perfectly!' },
  { id: 9, title: 'Speed Dating', excerpt: 'A joke about Kalenjin girls and their fast running...', fullText: 'Why did the Kalenjin girl win at speed dating? Because she’s always ahead in the “race” for your heart!' },
  { id: 10, title: 'Booty Call', excerpt: 'A joke about Luo girls and their physical traits...', fullText: 'Why did the Luo girl never need a GPS? Because her “big” heart always finds the way!' },
  { id: 11, title: 'Chatty Kisii', excerpt: 'A joke about Kisii girls and their talking habits...', fullText: 'Why did the Kisii girl bring a speaker to the date? Because she wanted to share her “sound” opinion with you!' },
  { id: 12, title: 'Witchcraft and Romance', excerpt: 'A joke about Kamba girls and their cultural practices...', fullText: 'Why did the Kamba girl bring a magic wand to dinner? To “enchant” you with her spellbinding charm!' },
  { id: 13, title: 'Potato Love', excerpt: 'A joke about Kikuyu girls and their love for potatoes...', fullText: 'Why did the Kikuyu girl call you her “mash”ed potatoes? Because you’re “sweet” and always on her mind!' },
  { id: 14, title: 'Financially Fluent', excerpt: 'A joke about Kikuyu girls and financial savvy...', fullText: 'Why did the Kikuyu girl bring her accountant to the date? To ensure her “love” budget is well accounted for!' },
  { id: 15, title: 'Marathon Love', excerpt: 'A joke about Kalenjin girls and their speed...', fullText: 'Why did the Kalenjin girl run circles around you? Because even in love, she’s always “ahead” of the game!' },
  { id: 16, title: 'Big Hearted Luo', excerpt: 'A joke about Luo girls and their physical traits...', fullText: 'Why do Luo girls always carry a map? Because their “big” heart leads them to find the best spots!' },
  { id: 17, title: 'Kisii Chatterbox', excerpt: 'A joke about Kisii girls and their talkative nature...', fullText: 'Why did the Kisii girl bring a megaphone to the date? Because she’s got “loud” and clear feelings for you!' },
  { id: 18, title: 'Magic in Kamba', excerpt: 'A joke about Kamba girls and their cultural practices...', fullText: 'Why did the Kamba girl bring a spellbook? To cast a “charming” spell on you during your date!' },
  { id: 19, title: 'Sweet Potatoes', excerpt: 'A joke about Kikuyu girls and their love for potatoes...', fullText: 'Why did the Kikuyu girl invite you to a potato feast? Because she wants you to know she’s “spud”tacularly into you!' },
  { id: 20, title: 'Cash and Charm', excerpt: 'A joke about Kikuyu girls and financial matters...', fullText: 'Why did the Kikuyu girl bring a briefcase to the date? Because she’s prepared to invest her “love” interest wisely!' },
  { id: 21, title: 'Running to Your Heart', excerpt: 'A joke about Kalenjin girls and their speed...', fullText: 'Why did the Kalenjin girl win the race to your heart? Because she’s “fast” at falling in love!' },
  { id: 22, title: 'Guiding Light', excerpt: 'A joke about Luo girls and their physical traits...', fullText: 'Why do Luo girls shine at night? Because their “big” hearts light up every room they enter!' },
  { id: 23, title: 'Kisii’s Sound Love', excerpt: 'A joke about Kisii girls and their chatty nature...', fullText: 'Why did the Kisii girl bring a radio to the date? To broadcast her “sound” feelings for you!' },
  { id: 24, title: 'Witchy Romance', excerpt: 'A joke about Kamba girls and their cultural background...', fullText: 'Why did the Kamba girl bring a cauldron to the date? To brew up some “magical” moments with you!' },
  { id: 25, title: 'Mashed Up Love', excerpt: 'A joke about Kikuyu girls and their love for potatoes...', fullText: 'Why did the Kikuyu girl bring a potato peeler to the date? To show that she’s peeling “madly” in love with you!' },
  { id: 26, title: 'Investment in Love', excerpt: 'A joke about Kikuyu girls and financial matters...', fullText: 'Why did the Kikuyu girl bring a calculator to the date? To ensure every “cent” of her love is perfectly counted!' },
  { id: 27, title: 'Speedy Romance', excerpt: 'A joke about Kalenjin girls and their running speed...', fullText: 'Why did the Kalenjin girl cross the finish line to your heart? Because even love is a “sprint” for her!' },
  { id: 28, title: 'Heartfelt Directions', excerpt: 'A joke about Luo girls and their physical traits...', fullText: 'Why do Luo girls never need a compass? Because their “big” hearts always guide them right to you!' },
  { id: 29, title: 'Chatty Kisii', excerpt: 'A joke about Kisii girls and their talkative nature...', fullText: 'Why did the Kisii girl carry a notepad to the date? To make sure she notes every “chat” you have!' },
  { id: 30, title: 'Enchanted Date', excerpt: 'A joke about Kamba girls and their cultural practices...', fullText: 'Why did the Kamba girl bring a wand to dinner? To sprinkle some “magic” on your evening together!' },
  { id: 31, title: 'Potato Heart', excerpt: 'A joke about Kikuyu girls and their love for potatoes...', fullText: 'Why did the Kikuyu girl take you to a potato patch? Because she wants you to know her heart is “rooted” in love!' },
  { id: 32, title: 'Capital Romance', excerpt: 'A joke about Kikuyu girls and financial savvy...', fullText: 'Why did the Kikuyu girl bring a banker to the date? To ensure her “investment” in you is a sure thing!' },
  { id: 33, title: 'Running Love', excerpt: 'A joke about Kalenjin girls and their speed...', fullText: 'Why did the Kalenjin girl run straight into your heart? Because love with her is a “fast track” to happiness!' },
  { id: 34, title: 'Big Hearted Luo', excerpt: 'A joke about Luo girls and their physical traits...', fullText: 'Why did the Luo girl bring a heart-shaped balloon? Because her “big” heart always wants to make you smile!' },],
      isModalOpen: false,
      currentPost: null,
      hammerInstance: null,
    };
  },
  methods: {
    openModal(post) {
      this.currentPost = post;
      this.isModalOpen = true;
      this.$nextTick(() => {
        this.addSwipeListeners();
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentPost = null;
      this.removeSwipeListeners();
    },
    prevPost() {
      const currentIndex = this.posts.indexOf(this.currentPost);
      if (currentIndex > 0) {
        this.currentPost = this.posts[currentIndex - 1];
      }
    },
    nextPost() {
      const currentIndex = this.posts.indexOf(this.currentPost);
      if (currentIndex < this.posts.length - 1) {
        this.currentPost = this.posts[currentIndex + 1];
      }
    },
    addSwipeListeners() {
      if (this.$refs.modalContent) {
        this.hammerInstance = new Hammer(this.$refs.modalContent);
        this.hammerInstance.on('swipeleft', this.nextPost);
        this.hammerInstance.on('swiperight', this.prevPost);
      }
    },
    removeSwipeListeners() {
      if (this.hammerInstance) {
        this.hammerInstance.off('swipeleft', this.nextPost);
        this.hammerInstance.off('swiperight', this.prevPost);
        this.hammerInstance = null;
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 2rem;
  margin-bottom: 20px;
}

.post {
  margin-bottom: 20px;
}

.post-preview {
  cursor: pointer;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.post-preview:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.post-title {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.post-excerpt {
  font-size: 1rem;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  background-color: black;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  animation: fadeIn 0.3s ease;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.modal-content p {
  font-size: 1rem;
  line-height: 1.5;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

.nav-button {
  background: rgba(0, 123, 255, 0.5); /* Adjust the alpha value (0.5) for transparency */
  border: none;
  color: white;
  padding: 10px;
  border-radius: 1px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.nav-button.prev {
  left: 0px;
}

.nav-button.next {
  right: 0px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
